import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import api from '../lib/apiClient';
import { IconButton } from '../components/IconButton';
import { IconBack } from '../components/icons';
import { StatementsPanel } from '../components/StatementsPanel';

export function MemberStatements() {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [memberName, setMemberName] = useState('');

  useEffect(() => {
    api
      .get<{ first_name: string | null; last_name: string | null }>(`/members/${id}`)
      .then((res) => setMemberName(`${res.data.first_name ?? ''} ${res.data.last_name ?? ''}`.trim()));
  }, [id]);

  return (
    <>
      <header className="page-header">
        <h1>Statements{memberName ? ` — ${memberName}` : ''}</h1>
        <div className="page-header-actions">
          <IconButton icon={IconBack} label="Back to member" onClick={() => navigate(`/memberships/${id}`)} />
        </div>
      </header>

      <StatementsPanel memberId={Number(id)} memberName={memberName} />
    </>
  );
}
